import { createSelector } from 'reselect';
import { ReduxState } from '../state';
import {
  InstitutionEnrolmentsState,
  InstitutionEnrolment,
  PortalViewAccess,
} from './state';
import { selectCurrentInstitutionPath } from '../Institutions/CurrentInstitutionPath/selectors';

const InstitutionEnrolmentsSelector = (
  state: ReduxState
): InstitutionEnrolmentsState => state.InstitutionEnrolments;

export const selectCurrentInstitutionEnrolment = createSelector(
  InstitutionEnrolmentsSelector,
  selectCurrentInstitutionPath,
  (
    institutionEnrolments,
    currentInstitutionPath
  ): InstitutionEnrolment | null => {
    return institutionEnrolments[currentInstitutionPath];
  }
);

export const selectCurrentInstitutionEnrolmentPortalViewAccess = createSelector(
  selectCurrentInstitutionEnrolment,
  (currentInstitutionEnrolment): PortalViewAccess | null => {
    return currentInstitutionEnrolment
      ? currentInstitutionEnrolment.portalViewAccess
      : null;
  }
);

export const selectCurrentInstitutionEnrolmentIsEnrolled = createSelector(
  selectCurrentInstitutionEnrolment,
  (currentInstitutionEnrolment): boolean | null => {
    return currentInstitutionEnrolment
      ? currentInstitutionEnrolment.isEnrolled
      : null;
  }
);

export const selectCurrentInstitutionEnrolmentPath = createSelector(
  selectCurrentInstitutionEnrolment,
  (currentInstitutionEnrolment): string | null => {
    return currentInstitutionEnrolment
      ? currentInstitutionEnrolment.path
      : null;
  }
);
